// extracted by mini-css-extract-plugin
export default {"resetButton":"xSXxncx","root":"p3up0Ic","icon":"h24ovy7","failed":"jdDBBTX","button":"zuOvc1w","countPreloader":"DxkLdVR","version":"iOwLEET"};